import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import {utility} from 'src/app/common/utility';
import { AlertService } from 'src/app/services/AlertService';
import { NewsService } from 'src/app/services/NewsService';
import { environment } from 'src/environments/environment';
import { AccountService } from '../../services/AccountService';

@Component({
  selector: 'app-viewnewsitem',
  templateUrl: './news-view-item.component.html',
  styleUrls: ['./news-view-item.component.scss']
})
export class ViewnewsitemComponent implements OnInit {

  msgs: Message[];
    newsItem: any;
    canDeleteNews: boolean = false;

  constructor(private newsService: NewsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private breadcrumbService: AppBreadcrumbService,
      private alertService: AlertService,
      private accountService: AccountService) { }

    ngOnInit(): void {      
        this.newsItem = this.activatedRoute.snapshot.data['newsItem'];
        this.breadcrumbService.setItems([
            { label: 'News', routerLink: [''] },
            { label: 'News #' + this.newsItem.Id, routerLink: [] }
        ]);
        this.canDeleteNews = this.accountService.CanDeleteNews();
    }

  getDocumentUrl(doc: any): string {
    var result = environment.imageBase.concat('/', doc.DocumentURI);
    return result;
  }

  OpenUrl(doc: any) {
    var url = this.getDocumentUrl(doc);
    utility.OpenURl(url);
   
  }

  removeNewsItem() {
    this.newsService.RemoveNewsMessage(this.newsItem.Id).subscribe(
      result => {
        this.router.navigate(['']);

      },
      error => {
        this.alertService.SetMessage('error', 'There is an error while deleting news');
      }
    )
  }
  
  getIcon(doc):string
  {
    let fileicon = utility.getDocumentIconClass(doc);
    return fileicon;
  }
}
